export const BG_PRIMARY = '#FFF';
export const BG_SECONDARY = '#6f8963';
export const BG_ALTERNATIVE = '#CFB4B4';

export const TEXT_PRIMARY = '#352023';
export const TEXT_SECONDARY = '#FFF';
export const TEXT_PRIMARY_LIGHT = '#FFF';

export const BTN_NAVIGATION_COLOR = '#352023';

// Opacity layer for left content (Desktop view)
export const BG_SECONDARY_TRANSPARENT = '';
